import React from 'react';
import {LoadingBar} from '@fupa/fupa-uikit';
import {Backdrop} from '@mui/material';
import styled from 'styled-components';

const StyledLoadingBar = styled(LoadingBar)`
  &&& {
    position: relative;
  }
`;

const StyledBackdrop = styled(Backdrop)`
  &&& {
    z-index: 6000000;
    background-color: rgba(256, 256, 256, 0.6);
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    align-items: flex-start;
  }
`;

const LoadingOverlay = ({open}) => {
  return (
    <StyledBackdrop open={open}>
      <StyledLoadingBar />
    </StyledBackdrop>
  );
};

export {LoadingOverlay};
